import { render, staticRenderFns } from "./packageF.vue?vue&type=template&id=049d7c94&scoped=true&"
import script from "./packageF.vue?vue&type=script&lang=js&"
export * from "./packageF.vue?vue&type=script&lang=js&"
import style0 from "./packageF.vue?vue&type=style&index=0&id=049d7c94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d7c94",
  null
  
)

export default component.exports